import ValidSignChart from './ValidSignChart';

export default ValidSignChart;
